import { connect } from 'react-redux';
import WidgetContainer from './components';
import algorithms from './constants/algorithms';

import {
	fetchBowVendors,
	fetchPvRecCrossCatRosVendors,
	fetchPvRecCrossCatVendors,
	fetchSimilarVendors,
} from './actions';

/** @knipignore */
export function mapStateToProps(state) {
	const recommendedVendors = [];

	recommendedVendors[algorithms.SIMILAR] =
		state.widget.similarVendorsReducer.recommendedVendors;
	recommendedVendors[algorithms.SIMILAR_ROS] =
		state.widget.similarVendorsReducer.recommendedVendors;
	recommendedVendors[algorithms.BOW] =
		state.widget.bowVendorsReducer.recommendedVendors;
	recommendedVendors[algorithms.PVREC_CROSS_CAT] =
		state.widget.pvRecCrossCatVendorsReducer.recommendedVendors;
	recommendedVendors[algorithms.PVREC_CROSS_CAT_ROS] =
		state.widget.pvRecCrossCatVendorsReducer.recommendedVendors;

	return {
		member: state.membership.member,
		vendor: state.vendor.vendor,
		location: state.location,
		viewport: state.viewport,
		recommendedVendors,
	};
}

/** @knipignore */
export const mapDispatchToProps = {
	fetchSimilarVendors,
	fetchBowVendors,
	fetchPvRecCrossCatVendors,
	fetchPvRecCrossCatRosVendors,
};

/** @knipignore */
export const mergeProps = (stateProps, dispatchProps, ownProps) => {
	const rosAlgorithmTypes = {
		[algorithms.SIMILAR]: algorithms.SIMILAR_ROS,
		[algorithms.PVREC_CROSS_CAT]: algorithms.PVREC_CROSS_CAT_ROS,
	};
	const fetchSimilarVendorsWithRos = (
		vendor,
		limit,
		radius,
		location,
		version,
		ivol,
	) =>
		dispatchProps.fetchSimilarVendors(
			vendor,
			limit,
			radius,
			location,
			version,
			ivol,
			true,
		);

	return {
		...ownProps,
		...stateProps,
		...dispatchProps,
		algorithmType:
			rosAlgorithmTypes[ownProps.algorithmType] || ownProps.algorithmType,
		fetchSimilarVendors: fetchSimilarVendorsWithRos,
		fetchPvRecCrossCatVendors: dispatchProps.fetchPvRecCrossCatRosVendors,
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps,
)(WidgetContainer);
